/*
 *   Copyright (c) 2020 BuserNet Consulting LLC
 *   All rights reserved.
 */
import ChartConst from '../../../constants/chart.constant';
import bnChartDataProcessService from '../../../services/chartDataProcess.service';
import d3 from '../../../globalexports/d3.export';

function routePrecepitationChartService() {
  const content = {};
  content.drawChart = (
    sourceData,
    chartData,
    chartObj,
    chartHeight,
    width,
    topSpace,
    x,
    y1,
    y2,
  ) => {
    if (!sourceData) {
      return null;
    }

    // Y-Axis left side ChartConst
    const yAxisLeft = d3.axisRight()
      .scale(y1)
      .ticks(ChartConst.GraphConfig.yAxis.ticks)
      .tickFormat((d) => bnChartDataProcessService.getPercentageTicksText(d, ChartConst
        .ChartLabelSpecs.p06.tooltip, false))
      .tickSizeInner(0) // To show horizontal gridlines
      .tickSizeOuter(0)
      .tickPadding(ChartConst.GraphConfig.yAxis.tickPadding);
    // yAxisLeftMinor is for drawing ticks line inside chart
    const yAxisLeftMinor = d3.axisLeft()
      .scale(y1)
      .ticks(ChartConst.GraphConfig.yAxis.ticks)
      .tickFormat('')
      .tickSizeInner(-width) // To show horizontal gridlines
      .tickSizeOuter(0)
      .tickPadding(ChartConst.GraphConfig.yAxis.tickPadding);

    // YLeft Line ChartConst
    const line1 = d3.line()
      .curve(ChartConst.bnd3Curve)
      .defined((d) => d.y !== null)
      .x((d) => x(d.x))
      .y((d) => y1(d.y));
    // YRight Line ChartConst
    const line2 = d3.line()
      .curve(ChartConst.bnd3Curve)
      .defined((d) => d.y !== null)
      .x((d) => x(d.x))
      .y((d) => y2(d.y));
    const areaLeft = d3.area()
      .curve(ChartConst.bnd3Curve)
      .defined((d) => d.y !== null)
      .x((d) => x(d.x))
      .y0(chartHeight)
      .y1((d) => y1(d.y));
    const areaRight = d3.area()
      .curve(ChartConst.bnd3Curve)
      .defined((d) => d.y !== null)
      .x((d) => x(d.x))
      .y0(chartHeight)
      .y1((d) => y2(d.y));
    // Setting Domain for X-axis
    x.domain(d3.extent(sourceData, (d) => d.arrival_time));

    // Setting Domain for Precipitaition chart
    y1.domain([ChartConst.precepitationDomain.min - ChartConst.precepitationDomain.minOffset,
      ChartConst.precepitationDomain.max + ChartConst.precepitationDomain.maxOffset,
    ]);
    y2.domain([ChartConst.q06Domain.min - ChartConst.q06Domain.max / chartHeight, ChartConst
      .q06Domain.max,
    ]);

    // Drawing Y-axis left tick lines
    chartObj.append('g')
      .attr('class', 'y axis y-left y-grid-line-container')
      .call(yAxisLeftMinor);
    chartObj.append('g')
      .attr('class', 'y axis y-left y-left-tick-highlighter')
      .call(yAxisLeftMinor);
    const range = chartObj.selectAll('.series')
      .data(chartData)
      .enter().append('g')
      .attr('class', (d) => `series-${d.sequence}`);
    range.append('path')
      .attr('class', (d) => `line data-line-route${d.area
        ? ' line-area'
        : ''}`)
      .attr('d', (d) => (d.yAxis === 1
        ? line1(d.values)
        : line2(d.values)))
      .style('stroke', (d) => d.color);
    range.append('path')
      .attr('class', 'area')
      .attr('fill', (d) => d.areaColor)
      .attr('d', (d) => {
        if (d.area) {
          // Draw area only if area flag is true for a given series
          return (d.yAxis === 1
            ? areaLeft(d.values)
            : areaRight(d.values));
        }
        return '';
      });

    // Drawing Y-axis left
    chartObj.append('g')
      .attr('class', 'y axis y-left')
      .call(yAxisLeft);
    // Draw a vertical line instead of y-axis right
    chartObj.append('line')
      .classed('y-line-right', true)
      .attr('x1', width)
      .attr('y1', 0)
      .attr('x2', width)
      .attr('y2', chartHeight);
    chartObj.append('rect')
      .attr('class', 'clear-rect')
      .attr('x', -1)
      .attr('y', (chartHeight))
      .attr('width', width + 2)
      .attr('height', topSpace / 2);
    return chartData;
  };
  return content;
}
export default routePrecepitationChartService();
